/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EncuestasPacPacienteModelDto } from '../../models/encuestas-pac-paciente-model-dto';

export interface EncuestasControllerGetEncuestasPaciente$Params {
}

export function encuestasControllerGetEncuestasPaciente(http: HttpClient, rootUrl: string, params?: EncuestasControllerGetEncuestasPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EncuestasPacPacienteModelDto>>> {
  const rb = new RequestBuilder(rootUrl, encuestasControllerGetEncuestasPaciente.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EncuestasPacPacienteModelDto>>;
    })
  );
}

encuestasControllerGetEncuestasPaciente.PATH = '/api/paciente-encuestas/encuestas-paciente';
